import { gql } from '@/__generated__';

const GET_DGA_MAX_FLOW = gql(`#graphql
  query GetDgaMaxFlow($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      profile {
        id
        name
      }
      dga {
        id
        configuration {
          id
          maxFlow
        }
      }
    }
  }
`);

export default GET_DGA_MAX_FLOW;
